import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/digitala-tjanster";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/digitala-tjanster")(withAlternates(routeOptions, "/digitala-tjanster"));
